import { BaseEdge } from "@xyflow/react";

const curve = (a, b) => { const mx = (a.x + b.x) / 2; return `C ${mx} ${a.y} ${mx} ${b.y} ${b.x} ${b.y}`; };

// Bezier edge that runs through reserved lane points so it never crosses behind a card.
export default function RoutedEdge({ id, sourceX, sourceY, targetX, targetY, data, style, markerEnd, label, labelStyle, labelBgStyle }) {
  const w = data?.width || 240;
  const pts = [{ x: sourceX, y: sourceY }];
  (data?.points || []).forEach((p) => { pts.push({ x: p.x, y: p.y }, { x: p.x + w, y: p.y }); });
  pts.push({ x: targetX, y: targetY });
  let d = `M ${pts[0].x} ${pts[0].y}`;
  for (let i = 1; i < pts.length; i++) d += i % 2 === 1 ? ` ${curve(pts[i - 1], pts[i])}` : ` L ${pts[i].x} ${pts[i].y}`;
  const a = pts[pts.length - 2], b = pts[pts.length - 1];
  return <BaseEdge id={id} path={d} style={style} markerEnd={markerEnd} label={label} labelX={(a.x + b.x) / 2} labelY={(a.y + b.y) / 2}
    labelStyle={labelStyle} labelBgStyle={labelBgStyle} />;
}
